import {
  Badge,
  Box,
  Card,
  Table,
  TableBody,
  TableBodyCell,
  TableBodyRow,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  Text,
  theme,
} from "@aksara-ui/react";
import { InputSearchbox } from "components/Form/InputSearchbox";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { getAllPointActivities } from "redux/actions";
import styled from "styled-components";
import {
  Pagination,
  PaginationDetail,
  PaginationFilter,
} from "components/Pagination";
import TableBodyRowsSkeleton from "components/TableBodyRowSkeleton";
import moment from "moment";
import FilterKit from "components/FilterKit";

const HeaderWrapper = styled(Box)`
  justify-content: space-between;
  margin-bottom: 30px;
  gap: 20px;
`;

const PointActivityContent: React.FC = () => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 576 });
  const isTablet = useMediaQuery({ maxWidth: 1024 });

  const { isLoading } = useSelector((state: any) => state.globalReducer);
  const { pointActivities, poinTypeFilters } = useSelector(
    (state: any) => state.pointActivityReducer
  );
  const { currentPage, totalPage, limitPage, lengthPage, filterPointTypePage } =
    useSelector((state: any) => state.pointActivityReducer);

  const [searchValue, setSearchValue] = useState("");
  const [limit, setLimit] = useState(10);

  const handleSearchChange = (event: any) => {
    setSearchValue(event.target.value);
    dispatch(
      getAllPointActivities(
        1,
        event.target.value,
        limitPage,
        filterPointTypePage
      ) as any
    );
  };

  const handleClearSearchChange = () => {
    setSearchValue("");
    dispatch(
      getAllPointActivities(
        currentPage,
        "",
        limitPage,
        filterPointTypePage
      ) as any
    );
  };

  useEffect(() => {
    dispatch(getAllPointActivities() as any);
  }, [dispatch]);

  return (
    <Box height={"100%"} paddingY={20} paddingX={isMobile ? 30 : 50}>
      <HeaderWrapper
        display={"flex"}
        flexDirection={"column"}
        style={{ gap: 20 }}
      >
        <Box display={"flex"}>
          <Text scale={[500, 600]} fontWeight={700}>
            Point Activity
          </Text>
        </Box>

        <Box
          display={"flex"}
          flexDirection={isTablet ? "column" : "row"}
          justifyContent={"left"}
          style={{ gap: 5 }}
        >
          <InputSearchbox
            autoComplete="off"
            name="search"
            placeholder="Search..."
            size={32}
            onChange={handleSearchChange}
            onClearButton={handleClearSearchChange}
          />

          <FilterKit
            orderByOptions={[
              {
                key: poinTypeFilters,
                label: "Type",
                options: poinTypeFilters.map((type: any) => {
                  return {
                    label: type.label,
                    value: type.value !== "all" ? type.value : "",
                  };
                }),
              },
            ]}
            onChangeOrder={(e: any) => {
              dispatch(
                getAllPointActivities(
                  1,
                  "",
                  limitPage,
                  e[poinTypeFilters] ? e[poinTypeFilters].value : ""
                ) as any
              );
            }}
          />
        </Box>
      </HeaderWrapper>

      <Card maxHeight={"100%"} overflow={"auto"} elevation={2}>
        <Table>
          <TableHead
            position={"sticky"}
            top={0}
            backgroundColor={theme.colors.grey02}
          >
            <TableHeadRow>
              <TableHeadCell>User</TableHeadCell>
              <TableHeadCell>Source</TableHeadCell>
              <TableHeadCell>Description</TableHeadCell>
              <TableHeadCell minWidth={150}>Type</TableHeadCell>
              <TableHeadCell>Point</TableHeadCell>
              <TableHeadCell>Date/Time</TableHeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableBodyRowsSkeleton rowsNumber={10} columnsNumber={6} />
            ) : !pointActivities.length ? (
              <TableBodyRow>
                <TableBodyCell colSpan={6} textAlign={"center"}>
                  No data available in table
                </TableBodyCell>
              </TableBodyRow>
            ) : (
              pointActivities.map((point: any) => {
                return (
                  <TableBodyRow key={point.id}>
                    <TableBodyCell>{point.user.name}</TableBodyCell>
                    <TableBodyCell>{point.source}</TableBodyCell>
                    <TableBodyCell>{point.description}</TableBodyCell>
                    <TableBodyCell>
                      <Badge
                        size="md"
                        variant={point.point_type === "0" ? "warning" : "info"}
                      >
                        {point.point_type === "0"
                          ? "Exp Point"
                          : "Ancol Point"}
                      </Badge>
                    </TableBodyCell>
                    <TableBodyCell>
                      <Badge
                        size="md"
                        variant={
                          point.is_increase_point ? "success" : "critical"
                        }
                      >
                        {point.is_increase_point
                          ? "+" + point.point
                          : "-" + point.point}
                      </Badge>
                    </TableBodyCell>
                    <TableBodyCell>
                      {moment(point.created_at).format(
                        "DD MMMM YYYY, HH:mm:ss"
                      )}
                    </TableBodyCell>
                  </TableBodyRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </Card>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        paddingY={10}
      >
        {!isMobile ? (
          <PaginationDetail
            page={currentPage}
            limit={limitPage}
            length={lengthPage}
          />
        ) : (
          ""
        )}
        <Pagination
          current={currentPage}
          total={totalPage}
          onSelect={(select: any) =>
            dispatch(
              getAllPointActivities(
                select,
                searchValue,
                limitPage,
                filterPointTypePage
              ) as any
            )
          }
        />
        <PaginationFilter
          selectedItem={limit}
          onChange={(selectedItem) => {
            if (selectedItem) {
              setLimit(selectedItem);
              dispatch(
                getAllPointActivities(
                  1,
                  searchValue,
                  selectedItem,
                  filterPointTypePage
                ) as any
              );
            }
          }}
          items={[10, 20, 30, 40, 50]}
        />
      </Box>
    </Box>
  );
};

export default PointActivityContent;
